var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    {
      staticClass: "wizard-navigation px-3 fixed-bottom bg-white py-3",
      attrs: { fluid: "" },
    },
    [
      _vm.title !== undefined && _vm.title !== ""
        ? [
            _vm.showTop
              ? _c(
                  "div",
                  {
                    staticClass:
                      "navigation-title d-flex w-100 justify-content-center text-brand-dark align-items-center",
                  },
                  [
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                    _c(
                      "a",
                      { staticClass: "link-text", attrs: { href: _vm.link } },
                      [_vm._v(_vm._s(_vm.linkText))]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.showTop ? _c("hr", { staticClass: "my-3" }) : _vm._e(),
          ]
        : _vm._e(),
      _c(
        "div",
        { staticClass: "navigation-progress d-flex align-items-center px-3" },
        [
          _c("h5", { staticClass: "text-brand-light d-none d-sm-block" }, [
            _vm._v(
              _vm._s(_vm.t.general_Step) +
                " " +
                _vm._s(_vm.currentStep + 1) +
                " " +
                _vm._s(_vm.lowerCaseTranslation) +
                " " +
                _vm._s(_vm.totalSteps + 1)
            ),
          ]),
          _c("h5", { staticClass: "text-brand-light d-sm-none mb-0" }, [
            _vm._v(
              _vm._s(_vm.currentStep + 1) + "/" + _vm._s(_vm.totalSteps + 1)
            ),
          ]),
          _c("b-progress", {
            staticClass: "progress-bar-light",
            attrs: { value: _vm.currentStep + 1, max: _vm.totalSteps + 1 },
          }),
          _c(
            "div",
            { staticClass: "buttons d-flex" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn-light btn-outline-primary",
                  attrs: { disabled: _vm.disabledBackButton },
                  on: {
                    click: function ($event) {
                      return _vm.back()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.t.general_Back))]
              ),
              _c(
                "span",
                { attrs: { id: "next-button-wrapper" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-light m-0",
                      attrs: { disabled: _vm.disableNextButton },
                      on: {
                        click: function ($event) {
                          return _vm.next()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.getNextButtonText))]
                  ),
                ],
                1
              ),
              _c(
                "b-tooltip",
                {
                  attrs: {
                    target: "next-button-wrapper",
                    delay: "100",
                    disabled: !_vm.disableNextButton,
                  },
                },
                [_vm._v(_vm._s(_vm.disableNextStepReason))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }